import script from "./SummaryReportSouthbound.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryReportSouthbound.vue?vue&type=script&setup=true&lang=js"

import "./SummaryReportSouthbound.vue?vue&type=style&index=0&id=e44ad7a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e44ad7a4"]])

export default __exports__